import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AdminPage } from './admin/AdminPage';
import { RegistrationLoader } from './registration/RegistrationLoader';
import './index.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Admin routes — protected by Cognito auth (Requirement 8) */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/*" element={<AdminPage />} />

          {/* Public registration routes (Requirement 8.6) */}
          <Route path="/r" element={<RegistrationLoader />} />
          <Route path="/r/:inviterId" element={<RegistrationLoader />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
